module.exports = __webpack_public_path__ + "static/assets/b3dce1ce13f2e250145cc954a1b55b47.svg";